import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  Card,
  TabPane,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  CardBody,
  Row,
} from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import classnames from 'classnames';
import isUndefined from 'lodash/isUndefined';
import map from 'lodash/map';

import BusCardSummary from './BusCardSummary';
import BusCardTopRoutes from './BusCardTopRoutes';
import BusCardTopCompanies from './BusCardTopCompanies';
import TypeAnalyticsLoading from './TypeAnalyticsLoading';

import { OrderTypes } from '../../constants/orderTypes';

import firebaseApp from '../../services/Firebase';

export default function BusCard({ orders, reservations, parentLoading }) {
  const { messages } = useIntl();

  const [activeTab, setActiveTab] = useState('summary');
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStations();
  }, [orders]);

  useEffect(() => {
    if (parentLoading) setLoading(true);
  }, [parentLoading]);

  const loadStations = async () => {
    setLoading(true);

    const airports = {};
    const promises = [];
    for (let i = 0; i < orders.length; i++) {
      const order = orders[i];

      if (order.type === OrderTypes.BUS) {
        for (let j = 0; j < order.journeys.length; j++) {
          const journey = order.journeys[j];

          if (isUndefined(airports[journey.departureStation])) {
            promises.push(
              firebaseApp.getLocationFromName(journey.departureStation).get()
            );

            airports[journey.departureStation] = true;
          }

          if (isUndefined(airports[journey.arrivalStation])) {
            promises.push(
              firebaseApp.getLocationFromName(journey.arrivalStation).get()
            );

            airports[journey.arrivalStation] = true;
          }
        }
      }
    }

    const results = await Promise.all(promises);

    setStations(map(results, (result) => result.docs[0].data()));
    setLoading(false);
  };

  if (parentLoading || loading) {
    return (
      <Card className="mb-4">
        <CardHeader>
          <Nav tabs className="card-header-tabs justify-content-end">
            <div className="card-title flex-fill align-self-center pt-3">
              {messages['containers.dashboard.bus-card.title']}
            </div>
          </Nav>
        </CardHeader>

        <TabContent activeTab={'loading'}>
          <TabPane tabId="loading">
            <CardBody>
              <Row>
                <Colxx sm="12">
                  <TypeAnalyticsLoading />
                </Colxx>
              </Row>
            </CardBody>
          </TabPane>
        </TabContent>
      </Card>
    );
  }

  return (
    <Card className="mb-4">
      <CardHeader>
        <Nav tabs className="card-header-tabs justify-content-end">
          <div className="card-title flex-fill align-self-center pt-3">
            {messages['containers.dashboard.bus-card.title']}
          </div>
          <NavItem>
            <NavLink
              to="#"
              location={{}}
              className={classnames({
                active: activeTab === 'summary',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('summary');
              }}
            >
              {messages['containers.dashboard.card.summary']}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="#"
              location={{}}
              className={classnames({
                active: activeTab === 'top_routes',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('top_routes');
              }}
            >
              {messages['containers.dashboard.bus-card.best-stretch']}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="#"
              location={{}}
              className={classnames({
                active: activeTab === 'top_airline',
                'nav-link': true,
              })}
              onClick={() => {
                setActiveTab('top_airline');
              }}
            >
              {messages['containers.dashboard.bus-card.best-companies']}
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="summary">
          <BusCardSummary
            orders={orders}
            reservations={reservations}
            stations={stations}
          />
        </TabPane>
        <TabPane tabId="top_routes">
          <BusCardTopRoutes
            orders={orders}
            reservations={reservations}
            stations={stations}
          />
        </TabPane>
        <TabPane tabId="top_airline">
          <BusCardTopCompanies orders={orders} reservations={reservations} />
        </TabPane>
      </TabContent>
    </Card>
  );
}
